<div id="contact-us">
  <div class="info d-flex align-items-center flex-wrap pt-5">
		@for(dataItem of data; track dataItem; let index = $index) {
		<div class="d-flex align-items-center justify-content-center pb-2">
			<div class="d-flex flex-wrap px-3" [class]="mobileView ? 'w-100' : 'w-50'">
				@if(dataItem.title){
				<div class="break"></div>
				<span class="title mb-3">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + dataItem.title | translate }}</span>
				<div class="break"></div>
				} @for(content of dataItem.content; track content; let contentIndex = $index) {
				<p class="w-100 pb-2">
					@if (content.leading) {
					<strong>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.leading | translate }}</strong>
          <br>
					}
					{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.text | translate }}
				</p>
				<div class="break"></div>
				}
			</div>
		</div>
		<div class="break"></div>
		}
	</div>

	<div class="d-flex align-items-center justify-content-center flex-wrap">
		<div class="my-4 p-2" [class]="mobileView ? 'w-100' : 'w-50'">
			<form class="d-flex flex-wrap" [formGroup]="formGroup" #formContactInfoDirective="ngForm" (submit)="sendMessage(formContactInfoDirective)">
				<mat-form-field class="w-100 pb-3" appearance="outline">
					<mat-label>{{ 'LANDING.CONTACT_US_E_MAIL' | translate }}</mat-label>
					<input type="text" formControlName="emailFrom" matInput />
				</mat-form-field>

				<mat-form-field class="w-100 pb-3" appearance="outline">
					<mat-label>{{ 'LANDING.CONTACT_US_PHONE' | translate }}</mat-label>
					<input type="number" formControlName="phone" matInput />
				</mat-form-field>

				<mat-form-field class="w-100 pb-3" appearance="outline">
					<mat-label>{{ 'LANDING.CONTACT_US_SENDER' | translate }}</mat-label>
					<input type="text" formControlName="company" matInput />
				</mat-form-field>

				<mat-form-field class="w-100 pb-3" appearance="outline">
					<mat-label>{{ 'LANDING.CONTACT_US_MESSAGE' | translate }}</mat-label>
					<textarea matInput class="w-100 pb-1" formControlName="message" cdkTextareaAutosize cdkAutosizeMinRows="10" cdkAutosizeMaxRows="10"></textarea>
				</mat-form-field>

				<button type="submit" mat-raised-button color="primary" class="w-100" aria-label="send message button" [disabled]="formGroup.invalid || apiLoading.contactForm">
					@if(apiLoading.contactForm) {
					<mat-spinner diameter="20"></mat-spinner>
					} @else {
					<span>{{ 'BUTTON.SEND' | translate }}</span>
					}
				</button>
			</form>
		</div>

		<div class="break"></div>
	</div>
</div>
